import React, {useState, useRef} from 'react';
import {message, Modal} from 'antd';
import './style.module.css';
import GeneralModal, {GeneralModalRef} from '../../../molecules/Modals/general/component';
import {UserObject} from '../../../../utils/types';
import SelectRoleForm from '../../../molecules/Forms/SelectRole/component';
import {getCookie, setCookie} from 'typescript-cookie';
import authService from '../../../../services/authService';
import * as authActions from '../../../../store/modules/auth/actions';
import {useDispatch} from 'react-redux';

type FormProps = {
    visible: boolean;
    onClose: () => void;
    item?: UserObject | null;
};

const SelectRoleDialog = ({visible, onClose}: FormProps) => {
    const dispatch = useDispatch();
    const generalModalRef = useRef<GeneralModalRef>(null);
    const getRole = getCookie('roleType') || '';
    const [role, setRole] = useState(getRole);

    const handleRoleChange = async (role: string) => {
        setRole(role);

        try {
            const response = await authService.switchRole(role);
            const newToken = response?.data?.bearerToken;

            if (!newToken) throw new Error('No token received from switchRole response.');

            dispatch(authActions.loginSuccess(true, response.data));

            setCookie('token', newToken, {expires: 2 / 24, path: '/', sameSite: 'none', secure: true});
            setCookie('roleType', role, {path: '/'});
            onClose();

            setCookie('postRoleReload', '1', {path: '/', expires: 1 / 24});
            window.location.replace('/home');

        } catch (error: any) {
            message.error(error?.response?.data?.message || 'Failed to switch role');
        }
    };

    return (
        <Modal open={visible} centered maskClosable={false} width={350} className={'customModal'} onCancel={onClose}
               footer={null}>
            <SelectRoleForm role={role || ''} onTypeChange={handleRoleChange}/>
            <GeneralModal ref={generalModalRef}/>
        </Modal>
    );
};

export default SelectRoleDialog;